import { useRef, useState } from "react";
import { Box, TextField, Typography } from "@mui/material";
import { MathInputTools } from "./TypeDrawQuestionInput";
import { sanitizeTypedAnswerWithGivenUnit } from "../../../utils/answerMatchUtils";
import { parseCompoundParts, combineCompoundAnswer, CURRENCY_UNITS } from "../../../utils/answerUnitUtils";

const CompoundUnitInput = ({ units, value, onChange, showMathTools = false, trailing = null }) => {
  const inputRefs = useRef([]);
  const [activeIdx, setActiveIdx] = useState(0);

  const parts = parseCompoundParts(value, units);
  const emit = (next) => onChange(combineCompoundAnswer(next, units));

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1, gap: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexWrap: "wrap" }}>
          {units.map((unit, i) => {
            // A currency member sits BEFORE its box (£22), every other unit after it (60p).
            const isPrefix = CURRENCY_UNITS.includes(unit);
            const label = (
              <Typography sx={{ fontWeight: 700, fontSize: "1rem", userSelect: "none" }}>
                {unit}
              </Typography>
            );
            return (
              // Keyed by index, not unit: a compound may legitimately repeat a unit name.
              <Box key={i} sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                {isPrefix ? label : null}
                <TextField
                  size="small"
                  sx={{ width: "7ch" }}
                  inputProps={{ inputMode: "numeric", style: { textAlign: "center" } }}
                  inputRef={(el) => { inputRefs.current[i] = el; }}
                  value={parts[i] ?? ""}
                  onFocus={() => setActiveIdx(i)}
                  onChange={(e) => {
                    const next = [...parts];
                    next[i] = sanitizeTypedAnswerWithGivenUnit(e.target.value, unit, { isPrefix });
                    emit(next);
                  }}
                />
                {isPrefix ? null : label}
              </Box>
            );
          })}
        </Box>
        {trailing ? <Box>{trailing}</Box> : null}
      </Box>
      {showMathTools ? (
        <MathInputTools
          getInput={() => inputRefs.current[activeIdx] ?? null}
          getValue={() => parts[activeIdx] ?? ""}
          onChange={(newVal) => {
            const next = [...parts];
            next[activeIdx] = sanitizeTypedAnswerWithGivenUnit(newVal, units[activeIdx], { isPrefix: false });
            emit(next);
          }}
        />
      ) : null}
    </Box>
  );
};

export default CompoundUnitInput;
